<template>
  <div>
    <div class="flex col-grow justify-between" style="height: 160px !important;">
      <div class="col-grow flex justify-between h-full">
        <e-window-table fixed class="col-grow h-full"
                        :columns="['ID Leilão', 'Data', 'Lances efetuados', 'Arremates', 'Lotes pagos', 'Participação', '']"
        >
          <e-tr v-for="(data, index) in leiloes" :key="index">
            <e-td><a>{{data.codigo}}</a></e-td>
            <e-td>{{ data.data.date|formatDate('dd/MM/yyyy HH:mm:ss') }}</e-td>
            <e-td>{{data.lances}}</e-td>
            <e-td>{{data.arremates}}</e-td>
            <e-td>{{data.pagos}}</e-td>
            <e-td>
              <span v-if="data.arremates" style="color: #0055FF">Com arremate</span>
              <span v-else-if="data.lances" style="color: #07B156">Com lance</span>
              <span v-else style="color: #6807B1">Telespectador</span>
            </e-td>
            <e-td><a @click="open(data.id)"><i class="erp-icon search min"></i> </a></e-td>
          </e-tr>
          <e-tr v-if="!leiloes || !leiloes.length">
            <e-td style="text-align: left !important;" colspan="100%">
              Nenhum registro
            </e-td>
          </e-tr>
        </e-window-table>
      </div>
    </div>
    <e-table-pagination class="m-t-xs" v-model="page" :max="max" />
  </div>
</template>

<script>
import {ETd, ETr, EWindowTable, ETablePagination} from 'uloc-vue-plugin-erp'
import {historicoLeiloes} from '../../../../domain/arrematante/services'

export default {
  name: 'HistoricoLeiloes',
  props: {
    arrematante: {
      required: true
    }
  },
  components: {
    EWindowTable,
    ETr,
    ETd,
    ETablePagination
  },
  data () {
    return {
      leiloes: null,
      loading: false,
      page: 1,
      max: 1
    }
  },
  mounted () {
    this.load()
  },
  computed: {},
  methods: {
    load () {
      this.loading = true
      historicoLeiloes(this.arrematante.id, 50, 1, '')
        .then(({data}) => {
          if (!Array.isArray(data.result)) {
            return
          }
          this.max = data.total
          this.leiloes = data.result
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })
    },
    open (id) {
      console.log('open...')
    }
  }
}
</script>
